@if (!isEmbedded) {
  <wpp-header />
}

<main>
  <router-outlet />
</main>
